<form [formGroup]="FeeForm">
    <div class="card-body">
        <div class="col-sm-12 text-center">
            <div class="bc d-flex align-items-center pl-3">
                <img alt="Logo" src="../../assets/images/receipt.png" class="mh-45px pb-2">
                <div class="ml-2">
                    <h2 class="main-content-label mb-1 ml-2"><b>{{Certificate}} Fees
                        </b></h2>

                </div>
            </div>
        </div>
        <div class="row clearfix">
            <div *ngIf="!Transcript" class="table-responsive table-container mt-4 ">
                <table id="datatable" class="table table-bordered text-nowrap">
                    <thead>
                        <tr>
                            <th width="20%" class="f600">Head</th>
                            <th width="20%" class="f600">Head Name</th>
                            <th width="20%" class="f600">Fee Amount</th>
                        </tr>
                    </thead>

                    <tbody id="table_data" formArrayName="feeHeadArray">
                        <tr *ngFor="let fee of getfeeHeadArrayControls(); let i = index; let last = last "
                            [formGroupName]="i">
                            <td>
                                <input class="form-control  input-sm" readonly formControlName="FeeHead" maxlength="8"
                                    id="addone">
                            </td>
                            <td>
                                <input class="form-control input-sm" formControlName="HeadName" readonly>
                            </td>
                            <td *ngIf="ExamCurrency == 'INR' " >
                                <span class="currency-symbolTd">&#8377; </span>
                                <input class="input-sm" formControlName="FeeAmt" readonly>
                            </td>
                            <td *ngIf="ExamCurrency == 'USD' ">
                                <span class="currency-symbolTd">$</span>
                                <input class=" input-sm" formControlName="FeeAmt" readonly>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div *ngIf="Transcript && TranscriptData.CertStatus === 'Submitted'" class="table-responsive table-container mt-4 ">
                <table *ngIf="tableData.length > 0" id="datatable" class="table table-bordered text-nowrap">
                    <thead>
                        <tr>
                            <th width="20%" class="f600">Fee Head</th>
                            <th width="20%" class="f600 hidden">Head Name</th>
                            <th class="f600 nowidth">Fee Amount</th>
                        </tr>
                    </thead>

                    <tbody id="table_data" formArrayName="feeHeadArray">
                        <tr
                          *ngFor="let fee of getfeeHeadArrayControls(); let i = index; let last = last; let row of tableData"
                          [formGroupName]="i"
                          [class.head]="isHead(row)"
                          [class.subhead]="isSubhead(row)"
                        >
                          <!-- Column 1 -->
                          <td>
                            <input
                              [class.indented]="isSubhead(row)"
                              [class.head]="isHead(row)" 
                              class="form-control input-sm"
                              readonly
                              formControlName="FeeHead"
                              maxlength="50"
                              id="addone"
                            />
                          </td>
                      
                          <!-- Column 2 (Hidden) -->
                          <td class="hidden">
                            <input
                              [class.indented]="isSubhead(row)"
                              class="form-control input-sm"
                              formControlName="HeadName"
                              readonly
                            />
                          </td>
                      
                          <!-- Column 3 (Fee Amount - INR) -->
                          <td *ngIf="ExamCurrency === 'INR'">
                            <span class="currency-symbolTd">&#8377;</span>
                            <input [class.indented]="isSubhead(row)"
                            [class.head]="isHead(row)"  class="input-sm" formControlName="FeeAmt" readonly />
                          </td>
                      
                          <!-- Column 4 (Fee Amount - USD) -->
                          <td *ngIf="ExamCurrency === 'USD'">
                            <span class="currency-symbolTd">$</span>
                            <input [class.indented]="isSubhead(row)"
                            [class.head]="isHead(row)"  class="input-sm" formControlName="FeeAmt" readonly />
                          </td>
                        </tr>
                      </tbody>
                </table>
                <ul>
                    <li >Additional Set : {{TranscriptData.StuCertCopies}}</li>
                    <li >Delivery Option : {{TranscriptData.DeliveryOpt == 'Hard' ? 'Hard Copy' : (TranscriptData.DeliveryOpt == 'Soft' ? 'Soft Copy' : 'Both Hard Copy and Soft Copy')}}</li>
                </ul>
                
                <ul>Extra Charges: 
                    <li>1650/- per additional set for transcript.</li>
                    <li>750/- per additional set for postal charge(Hard Copy).</li>
                </ul>
            </div>

       
            <div class="col-sm-12 row">
                <div class="col-sm-3">
                    <!-- <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label class="ff">
                                    Pay Mode
                                </mat-label>
                                <mat-select #select35 class="colorblack ff" formControlName="PayMode">
                                    <mat-select-filter *ngIf="select35.focused" [placeholder]="'Filter'"
                                        [displayMember]="'CdDesc'" [array]="payModeList"
                                        (filteredReturn)="filteredpayModeList =$event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredpayModeList" [value]="item.CdCode">
                                        {{item.CdDesc}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </div>
                    </div> totalAmount-->
                </div>
                <div class="col-sm-6 mrg mrg1" *ngIf="ExamCurrency == 'INR' ">
                    <span class="Text">Total Amount :</span><span class="currency-symbol">&#8377;{{TotalFee || totalAmount}}
                    </span>
                    <br>

                    <!-- <span class="Text mr3">Amount To Be Paid:<span class="currency-symbolTd">&#8377;</span>
                    </span>

                    <mat-form-field appearance="outline" class="example-full-width  col-sm-3">
                        <input onkeydown="return (event.keyCode!=13);" maxlength="8" class="color ff1" matInput
                            formControlName="TotalPaidAmount" (keyup)="onInputChange($event)">

                    </mat-form-field>
                    <mat-error class="margin_tp ml1" *ngIf="zeroError">
                        Enter Valid Amount.
                    </mat-error>
                    <mat-error class="margin_tp" *ngIf="shouldShowErrorMessage">
                        Amount Should Not Be Greater Than Remainig Amount.
                    </mat-error>
                    <mat-error class="margin_tp err"
                        *ngIf="FeeForm.controls['TotalPaidAmount'].touched && FeeForm.controls['TotalPaidAmount'].errors?.required">
                        Mandatory
                    </mat-error> -->
                </div>
                <div class="col-sm-6 mrg mrg1" *ngIf="ExamCurrency == 'USD' ">
                    <span class="Text">Total Amount :</span><span class="currency-symbol">${{totalAmount}}
                    </span>
                    <br>

                    <!-- <span class="Text mr3">Amount To Be Paid:<span class="currency-symbolTd">$</span>
                    </span>

                    <mat-form-field appearance="outline" class="example-full-width  col-sm-3">
                        <input onkeydown="return (event.keyCode!=13);" maxlength="8" class="color ff1" matInput
                            formControlName="TotalPaidAmount" (keyup)="onInputChange($event)">

                    </mat-form-field>
                    <mat-error class="margin_tp ml1" *ngIf="zeroError">
                        Enter Valid Amount.
                    </mat-error>
                    <mat-error class="margin_tp" *ngIf="shouldShowErrorMessage">
                        Amount Should Not Be Greater Than Remainig Amount.
                    </mat-error>
                    <mat-error class="margin_tp err"
                        *ngIf="FeeForm.controls['TotalPaidAmount'].touched && FeeForm.controls['TotalPaidAmount'].errors?.required">
                        Mandatory
                    </mat-error>
                    <mat-error class="margin_tp err"
                        *ngIf="FeeForm.controls['TotalPaidAmount'].touched && FeeForm.controls['TotalPaidAmount'].errors?.pattern">
                        Please Enter Valid Data.
                    </mat-error> -->
                </div>
            </div>
            <!-- <div class="col-sm-12"  *ngIf="ExamCurrency == 'INR' ">
                <span class="Text mrg5">Total Remaining Amount :</span>
                <span class="currency-symbolTd">&#8377;{{remainAmt}}</span>
            </div>
            <div class="col-sm-12"  *ngIf="ExamCurrency == 'USD' ">
                <span class="Text mrg5">Total Remaining Amount :</span><span
                    class="currency-symbol Textmrg1">${{remainAmt}}</span>
            </div> -->
            <div class="col-sm-12">
                <button type="button" *ngIf="payHistoryBtn" class="btn btn-primary btn-icon-text floatright mt-1 fr"
                    (click)="openHistoryPopup()">
                    <span style="display: contents; align-items: center;">
                        <img width="25vh" src="../../assets/images/history.gif" style="margin-right: 5px;">
                        Payment History
                    </span>
                </button>
                <!-- <button type="button" *ngIf="updateButton " [disabled]="updateBtn"
                    class="btn fr btn-primary btn-icon-text floatright mt-1 mr-3 fr" (click)="updateFeeTemplet()">
                    <span style="display: contents; align-items: center;">
                        <img width="20vh" src="../../assets/images/save.gif" style="margin-right: 7px;">
                        Save
                    </span>
                </button> -->
                <!-- [disabled]="updateBtn"  -->
                <button type="button" *ngIf="submitButton" 
                class="btn fr btn-primary btn-icon-text floatright mt-1 fr" (click)="submitFeeTemplet()">
                    <!-- submitFeeTemplet() -->
                    <span style="display: contents; align-items: center;" >
                        <img width="20vh" src="../../assets/images/save.gif" style="margin-right: 5px;">
                        Save
                    </span>
                </button>
                <button type="button" class="btn fr btn-primary btn-icon-text floatright mr-3 mt-1 fr"
                    (click)="close()">
                    <span style="display: contents; align-items: center;">
                        <img width="20vh" src="../../assets/images/letter-x.gif" style="margin-right: 7px;">
                        Close
                    </span>
                </button>
            </div>
        </div>

    </div>
</form>